import { Heading } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

interface PageToolbarProps {
  actionButtons: React.ReactNode;
  title?: string | React.ReactNode;
  toolbarContainerClassName?: string;
}

export const PageToolbar: React.FC<PageToolbarProps> = ({
  actionButtons,
  title,
  toolbarContainerClassName,
}) => {
  const hasTitle = Boolean(title);

  const titleRenderer = () =>
    typeof title === 'string' ? (
      <Heading size="sm" className="truncate transition-all duration-500 mr-2">
        {title}
      </Heading>
    ) : (
      <div className="min-w-0 mr-2 truncate w-[-webkit-fill-available] flex-grow">
        {title}
      </div>
    );

  return (
    <div
      className={clsx(
        'flex items-center min-w-[calc(100%-46px)] py-3 sm:py-0 w-0 sm:w-full [&>h1]:leading-6',
        {
          'justify-between': hasTitle,
          'justify-end': !hasTitle,
        },
        toolbarContainerClassName,
      )}
    >
      {title ? titleRenderer() : null}
      <div className="flex shrink-0 justify-end whitespace-nowrap">
        {actionButtons}
      </div>
    </div>
  );
};
